import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Growth extends Bloc {

	constructor (src, ctx) {

		super("growth", src, ctx, true);
		this.f = (src, ins) => {

			src.master.player.grow(ins[0]);
			return [];
		};
		this.types = [Types.int];
	}
}